"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.SegmentedContext = react_1.createContext(null);
//# sourceMappingURL=SegmentedContext.js.map